import $ from 'jquery';
import _ from 'lodash';
import { getState } from '~src/state';
import { onBackgroundChange } from '~src/image';
import { isLoggedUserGlobalEditor, getUser } from '~src/user';
import { EdgeResizer } from '~src/utils';
import differenceInDays from 'date-fns/differenceInDays';

const htmlBackgrounds = async (backgrounds) => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  const { user } = await getUser();
  const { ids, html } = backgrounds.reduce(
    (acc, item) => {
      // Use larger previews to improve grid thumbnail size when rendering single-column
      const previewImg = new EdgeResizer(item.file.url).scaleToWidth(250);

      const itemId = `editor-sidebar-set-canvas-background-${item.objectId}`;
      let buttons = `<div class="option-button-container sidebar-context-menu-trigger bg-color-existing-canvas">
        <div class="option-button-container-relative">
          <div class="context-menu context-menu-child sidebar-context-menu bg-color-existing-canvas color-existing-canvas">
                  <div class="item context-menu-child"
                    data-backgrounds-item-id="${item.objectId}"
                    data-tab-target="tab-backgrounds-tag">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="sidebar-context-menu__icon">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                    </svg>
                    Dettagli
                  </div>`;

      if (
        isGlobalEditor ||
        user.org_pointer.objectId === item.org_pointer?.objectId
      ) {
        buttons += `
                  <div class="item context-menu-child item--danger" data-delete-backgrounds-id="${item.objectId}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path fill="currentColor" d="M8 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3h4.25a.75.75 0 1 1 0 1.5H19V18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6.5H3.75a.75.75 0 0 1 0-1.5H8zM6.5 6.5V18c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6.5h-11zm3-1.5h5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm-.25 4h1.5v8h-1.5V9zm4 0h1.5v8h-1.5V9z"></path>
                    </svg>
                    Elimina
                  </div>`;
      }

      buttons += `
                </div>
              </div>
            </div>`;

      acc.html += '<div class="sidebar-item-grid-box image-square-container">';

      if (
        differenceInDays(new Date(), new Date(item.createdAt)) <= 30 &&
        item.isGlobal === true
      ) {
        acc.html += '<div class="sidebar-badge-new">Novità</div>';
      }

      acc.html += `<div id="${itemId}" data-url="${item.file.url}" class="sidebar-item-grid-box-click-listener"></div>`;

      if (!$(`#${itemId}`).length) {
        acc.html += `
          <img
            src="../assets/svg/img-loader.gif"
            class="lazy image-square"
            data-src="${previewImg}"
          />`;
      } else {
        acc.html += `
          <img
            src="${previewImg}"
            class="image-square"
          />`;
      }
      acc.html += `${buttons}</div>`;

      acc.ids.push(`#${itemId}`);

      return acc;
    },
    { ids: [], html: '' }
  );

  if (ids.length) {
    ids.forEach((id) => {
      $('body').off('click', id, onBackgroundChange);
      $('body').on('click', id, onBackgroundChange);
    });
  }
  return html;
};

const templateAddBackgroundsDefault = async (backgrounds) => {
  const backgroundsDefault = backgrounds.filter(
    (background) => background.isGlobal === true
  );

  let html;

  if (backgroundsDefault.length === 0) {
    html =
      '<div class="containerTextEmptyBox"><div class="textEmptyBox">Non ci sono sfondi disponibili</div></div>';
  } else {
    html = await htmlBackgrounds(backgroundsDefault);
  }

  $('#editor-sidebar-backgrounds').html(html);
};

const templateAddBackgroundsCustom = async (backgrounds) => {
  const { user } = await getUser();

  const backgroundsCustom = backgrounds.filter(
    (background) =>
      background.org_pointer?.objectId === user.org_pointer.objectId
  );

  let html;

  if (backgroundsCustom.length === 0) {
    html =
      '<div class="containerTextEmptyBox"><div class="textEmptyBox">Non ci sono sfondi disponibili</div></div>';
  } else {
    html = await htmlBackgrounds(backgroundsCustom);
  }

  $('#editor-sidebar-backgrounds-custom').html(html);
};

export const displaySidebarBackgrounds = async () => {
  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');

  const sidebarBackgrounds = _.get(
    window.editorConfig,
    `sidebarBackgrounds[${currentTag}]`,
    { items: [] }
  );

  await Promise.all([
    templateAddBackgroundsDefault(sidebarBackgrounds.items),
    templateAddBackgroundsCustom(sidebarBackgrounds.items),
  ]);

  window.lazyLoadInstance.update();
};
